export default __webpack_public_path__ + "static/media/330_business08-jp-mobile.5b3919a1.png";